import { ValueOfKey } from '../../../utils-types';

// TODO add options
export const CUSTOMER_STATUS = {
  ACTIVE: 'ACTIVE',
  INCOMPLETE: 'INCOMPLETE',
  CANCELED: 'CANCELED',
  PAYMENT_ISSUE: 'PAYMENT_ISSUE',
  PRE_REGISTERED: 'PRE_REGISTERED', // PRE-REGISTERED used in options ask BE possibility to use PRE_REGISTERED
} as const;

export type CustomerStatusType = ValueOfKey<typeof CUSTOMER_STATUS>;
